import { ISchool } from '../../../interfaces/school.interface'
import { ICourse, ICourseLessonContent } from '../../../interfaces/ICourse'
import { IPaymentsPlan } from '../../../interfaces/IPaymentsPlan'
import { IUserDetails } from '../../../interfaces/user.interface'
import React from 'react'
import StudentCourseDetailsCardActionButton from './StudentCourseDetailsCardActionButton'
import TeacherCourseDetailsActionButton from './TeacherCourseDetailsActionButton'
import OpenAuthDialogButton from '../../Auhentication/LoginComponent/OpenAuthDialogButton'
import CourseDetailsFeaturesIncluded from './CourseDetailsFeaturesIncluded'
import {
  formatAmount,
  showCoursePayButtonOnCourseDetailsPage,
} from '../../../services/utils'
import {
  removeURLQueryParameter,
  setURLQueryParameter,
} from '../../../services/config'
import { useRouter } from 'next/router'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

interface ICourseInfo {
  schoolDetailsFromCourse: ISchool
  courseDetails: ICourse
  courseLessonContent: Array<ICourseLessonContent>
  paymentPlans: IPaymentsPlan[]
  userDetails: IUserDetails | undefined
  mini?: boolean
  hideActionButton?: boolean
}

export default function CourseDetailsActionComponent(props: ICourseInfo) {
  const router = useRouter()
  const [showPaymentButtonSetting] = React.useState(
    showCoursePayButtonOnCourseDetailsPage({
      courseDetails: props.courseDetails,
    }),
  )

  React.useEffect(() => {
    const class_url = `/courses/content/${props.courseDetails._id}`
    router.prefetch(class_url)
  }, [])

  if (props.userDetails?.user_type === 'student') {
    return (
      <div>
        {!props.hideActionButton && (
          <StudentCourseDetailsCardActionButton
            course_details={props.courseDetails}
            user_details={props.userDetails}
            schoolDetailsFromCourse={props.schoolDetailsFromCourse}
            payment_plans={props.paymentPlans}
          />
        )}
        {!props.mini && (
          <CourseDetailsFeaturesIncluded
            courseDetails={props.courseDetails}
            schoolDetailsFromCourse={props.schoolDetailsFromCourse}
          />
        )}
      </div>
    )
  }

  if (
    props.userDetails &&
    ['teacher', 'admin'].includes(props.userDetails?.user_type as any)
  ) {
    return (
      <div>
        {!props.hideActionButton && (
          <TeacherCourseDetailsActionButton
            schoolDetailsFromCourse={props.schoolDetailsFromCourse}
            courseDetails={props.courseDetails}
            courseLessonContents={props.courseLessonContent}
            userDetails={props.userDetails}
            paymentPlans={props.paymentPlans}
          />
        )}
        {!props.mini && (
          <CourseDetailsFeaturesIncluded
            courseDetails={props.courseDetails}
            schoolDetailsFromCourse={props.schoolDetailsFromCourse}
          />
        )}
      </div>
    )
  }

  return (
    <div style={{ width: '100%' }}>
      {Boolean(props.courseDetails?.price) &&
        !props.courseDetails.disable_direct_registration &&
        showPaymentButtonSetting && (
          <div style={{ marginBottom: '10px' }}>
            {!props.hideActionButton && (
              <OpenAuthDialogButton
                buttonVariant={'outlined'}
                buttonTextComponent={
                  <>
                    Pay {`${props.schoolDetailsFromCourse?.currency_code}`}{' '}
                    {formatAmount(props.courseDetails?.price)} for course
                  </>
                }
                school={props.schoolDetailsFromCourse}
                onAuthDialogOpenStateChange={(isOpen, isCancel) => {
                  if (isOpen) {
                    setURLQueryParameter('payButton', 'true')
                  } else if (isCancel) {
                    removeURLQueryParameter('payButton')
                  }
                }}
              />
            )}
          </div>
        )}
      <OpenAuthDialogButton
        buttonTextComponent={
          <>
            Open class{' '}
            <ArrowForwardIcon fontSize={'small'} style={{ color: '#fff' }} />
          </>
        }
        school={props.schoolDetailsFromCourse}
        onAuthDialogOpenStateChange={(isOpen, isCancel) => {
          if (isOpen) {
            setURLQueryParameter('openClass', 'true')
          } else if (isCancel) {
            removeURLQueryParameter('openClass')
          }
        }}
      />
      {/*<Typography style={{ marginTop: "5px" }} variant="body2" color="primary">*/}
      {/*  ! You need to be logged in to be a part of this course*/}
      {/*</Typography>*/}
      {!props.mini && (
        <CourseDetailsFeaturesIncluded
          courseDetails={props.courseDetails}
          schoolDetailsFromCourse={props.schoolDetailsFromCourse}
        />
      )}
    </div>
  )
}
